var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 86,
    viewBox: "0 0 77 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6669 53.7381V62.627M16.4447 33.8661C18.5399 33.7381 21.1228 33.7381 24.4447 33.7381H52.8891C56.2109 33.7381 58.794 33.7381 60.8891 33.8661M16.4447 33.8661C13.8299 34.0256 11.9748 34.3847 10.3915 35.1914C7.88262 36.4696 5.84288 38.5092 4.56457 41.0181C3.11133 43.8705 3.11133 47.6038 3.11133 55.0714V61.2936C3.11133 68.7612 3.11133 72.4945 4.56457 75.347C5.84288 77.8558 7.88262 79.8954 10.3915 81.1736C13.2436 82.627 16.9773 82.627 24.4447 82.627H52.8891C60.3567 82.627 64.09 82.627 66.9424 81.1736C69.4513 79.8954 71.4909 77.8558 72.7691 75.347C74.2224 72.4945 74.2224 68.7612 74.2224 61.2936V55.0714C74.2224 47.6038 74.2224 43.8705 72.7691 41.0181C71.4909 38.5092 69.4513 36.4696 66.9424 35.1914C65.3589 34.3847 63.5038 34.0256 60.8891 33.8661M16.4447 33.8661V24.8492C16.4447 12.5762 26.3939 2.62695 38.6669 2.62695C50.9398 2.62695 60.8891 12.5762 60.8891 24.8492V33.8661",
    stroke: "url(#paint0_linear_256_20034)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_256_20034",
    x1: 3.11133,
    y1: 42.627,
    x2: 74.2224,
    y2: 42.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.06579146e4d8292527d3fc7dc6ee70a8.svg";
export { ForwardRef as ReactComponent };